<script>
	import { masterData } from "src/store/store";

	export let row = {};
	export let key = "";

	let value = "";

	$: if (key === "carAssetOwners") {
		value =
			$masterData.carAssetOwners.find(
				(item) => item.id === row["assetOwnerId"]
			)?.name || "";
	}
	//  else if (key === "vehicleType") {
	//     row[key] = $masterData.vehicleTypes.find(
	//         (item) => item.id === row[key]
	//     )?.name || "";
	// } else if (key === "vehicleStatus") {
	//     row[key] = $masterData.vehicleStatuses.find(
	//         (item) => item.id === row[key]
	//     )?.name || "";
	// } else if (key === "caseStatus") {
	//     row[key] = $masterData.caseStatuses.find(
	//         (item) => item.id === row[key]
	//     )?.name || "";
	// }
</script>

<span>
	{value}
</span>
